import { IntelliUploadDocument, IntelliUploadQueueHistory } from "@/core/entities/IntelliUpload";

export enum IntelliUploadStatus {
  PENDING = "pending",
  PROCESSING = "processing",
  UPLOADED = "uploaded",
  FAILED = "failed",
}

export type DocumentType = "Backup" | "Remittance";

export interface IIntelliUploadNewDocumentResponse {
  data: {
    intelliUploadDocument: IntelliUploadDocument;
  };
}

export interface IIntelliUploadNewDocumentRequest {
  file: File;
  // type: DocumentType;
  queueId: string;
}

export interface IIntelliUploadClearIntelliUploadDocumentsRequest {
  queueId: string;
}

export interface IIntelliUploadClearIntelliUploadDocumentsResponse {
  clearQueue: {
    success: boolean;
    message: string;
  };
}

export interface IIntelliUploadProcessDocumentRequest {
  purchaserId: number;
  purchaserKey: string;
  filePath: string;
  fileChecksum: string;
  documentTypeId: number;
  documentSubtypeId: number;
}

export interface IIntelliUploadProcessDocumentsRequest {
  timeZone: string;
  queueId: string;
  documents: IIntelliUploadProcessDocumentRequest[];
}

export interface IIntelliUploadProcessDocumentResponse {
  documentId: number,
  parentDocumentId: number,
  purchaserName: string,
  purchaserKey: string,
  fileDisplayName: string,
  fileMimeType: string,
  documentTypeId: number,
  documentType: DocumentType,
  documentSubtypeId: number,
  documentSubtype: string,
  claimNumber: string,
  checkNumber: string,
}

export interface IIntelliUploadProcessDocumentsResponse {
  [key: string]: {
    isEmailSent?: boolean;
    isQueueCompleted?: boolean;
    isRuleTriggered?: boolean;
    queueId: string;
    documentCount: number;
    processId: string;
    message: string;
    documents: IIntelliUploadProcessDocumentResponse[];
  };
}

export interface IIntelliUploadInitiateRuleEngineDocumentRequest {
  documentId: number;
  documentType: DocumentType;
  number: string;
}

export interface IIntelliUploadInitiateRuleEngineRequest {
  processId: string;
  documents: IIntelliUploadInitiateRuleEngineDocumentRequest[];
}

export interface IIntelliUploadInitiateRuleEngineResponse {
  initiateRuleEngine: {
    success: boolean;
    message: string;
  };
}

export interface IIntelliUploadHistoryRequest {
  pageNumber: number;
  pageSize: number;
  timeZone?: string;
}
export interface IIntelliUploadHistoryResponse {
  queueList: {
    total: number;
    page: number;
    limit: number;
    items: IntelliUploadQueueHistory[];
  };
}

export interface IIntelliUploadRepository {
  uploadNewDocument(request: IIntelliUploadNewDocumentRequest): Promise<IIntelliUploadNewDocumentResponse>;
  clearDocuments(request: IIntelliUploadClearIntelliUploadDocumentsRequest): Promise<IIntelliUploadClearIntelliUploadDocumentsResponse>;
  processDocuments(request: IIntelliUploadProcessDocumentsRequest): Promise<IIntelliUploadProcessDocumentsResponse>;
  initiateRuleEngine(request: IIntelliUploadInitiateRuleEngineRequest): Promise<IIntelliUploadInitiateRuleEngineResponse>;
  getIntelliUploadHistory(request: IIntelliUploadHistoryRequest): Promise<IIntelliUploadHistoryResponse>;
  getIntelliUploadHistoryDetails(request: Omit<IIntelliUploadProcessDocumentsRequest, "documents">): Promise<IIntelliUploadProcessDocumentsResponse>;
}
